var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-block position-relative"},[(_vm.prevLink)?_c('a',{staticClass:"go-back",on:{"click":_vm.goPrev}},[_c('svg-icon',{attrs:{"icon":"arrow_w"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }